import { useRef, useState } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import { Link } from 'react-router-dom'
import { 
  ArrowRight, 
  ArrowUpRight, 
  Heart, 
  Briefcase, 
  PartyPopper, 
  Users, 
  Calendar, 
  MapPin, 
  Star,
  Sparkles,
  Award,
  Phone,
  Quote,
  FileText,
  ChevronLeft,
  ChevronRight,
  Coffee
} from 'lucide-react'

// Event-Kategorien Daten
const eventCategories = [
  {
    id: 'hochzeiten',
    title: 'Hochzeiten',
    subtitle: 'Your Forever Starts Here',
    tagline: 'Ihr schönster Tag',
    description: 'Traumhafte Hochzeitsfeiern in historischem Ambiente. Von der freien Trauung im Innenhof bis zur rauschenden Feier in der Festscheune.',
    image: '/home_pics/hochzeit.jpeg',
    link: '/hochzeiten',
    capacity: 'Bis 400 Gäste',
    icon: Heart,
    features: ['Freie Trauungen', 'Exklusive Nutzung', 'All-Inclusive Pakete']
  },
  {
    id: 'corporate',
    title: 'Firmenfeiern',
    subtitle: 'Where Business Meets Elegance',
    tagline: 'Professionell & beeindruckend',
    description: 'Weihnachtsfeiern, Sommerfeste, Tagungen und Kongresse. Moderne Technik trifft auf historischen Charme.',
    image: '/assets/home_pics/HK_184.jpg',
    link: '/unternehmensfeiern',
    capacity: 'Bis 2.000 Gäste',
    icon: Briefcase,
    features: ['Großveranstaltungen', 'Event-Technik', 'Full-Service Catering']
  },
  {
    id: 'private',
    title: 'Private Feiern',
    subtitle: 'Celebrate Life\'s Moments',
    tagline: 'Unvergessliche Momente',
    description: 'Geburtstage, Jubiläen und besondere Anlässe. Intime Feiern in außergewöhnlichem Ambiente.',
    image: '/assets/home_pics/DS2.JPG',
    link: '/private-feiern',
    capacity: 'Flexibel ab 30 Gäste',
    icon: PartyPopper,
    features: ['Individuelle Planung', 'Persönliche Betreuung', 'Maßgeschneiderte Menüs']
  }
]

// Statistiken
const stats = [
  { number: '25+', label: 'Jahre Erfahrung', icon: Award },
  { number: '2.000', label: 'Max. Gäste', icon: Users },
  { number: '500+', label: 'Events pro Jahr', icon: Calendar },
  { number: '5', label: 'Einzigartige Räume', icon: MapPin }
]

// Warum Hückels May
const whyUs = [
  {
    icon: Sparkles,
    title: 'Historisch einzigartig',
    description: 'Authentische Räume'
  },
  {
    icon: Users,
    title: 'Flexibel für jede Größe',
    description: '30 bis 2.000 Gäste'
  },
  {
    icon: Star,
    title: 'Rundum-Service',
    description: 'Alles aus einer Hand'
  },
  {
    icon: Heart,
    title: 'Mit Leidenschaft',
    description: '25+ Jahre Erfahrung'
  }
]

// Testimonials
const testimonials = [
  {
    id: 1,
    category: 'Brunch',
    categoryIcon: Coffee,
    name: 'Kathy Rik',
    text: 'Wir waren zum Brunchen am 2. Weihnachtstag dort. Das Ambiente ist sehr schön und gemütlich. Es wirkt rustikal, jedoch stylisch. Der Service ist sehr freundlich und aufmerksam. Das Essen ist köstlich und es wurde immer frisch nachgelegt, sodass man in Ruhe genießen konnte. Das Preis-Leistungsverhältnis ist absolut stimmig. Wir haben ein leckeres und gemütliches Weihnachts-Familien-Treffen dort verbracht und sagen Dankeschön.',
    rating: 5
  },
  {
    id: 2,
    category: 'Firmenfeier',
    categoryIcon: Briefcase,
    name: 'Heinemann DUS',
    text: 'Unsere Firmenfeier hier war ein voller Erfolg – ein Erlebnis, das wir so schnell nicht vergessen werden! Das Essen war köstlich und wurde mit viel Liebe zum Detail zubereitet. Das Team war ausgesprochen herzlich und hat uns jeden Wunsch von den Augen abgelesen. Man fühlt sich direkt wie zu Hause, was in dieser Branche nicht selbstverständlich ist. Die Location selbst ist einladend, rustikal; man merkt, dass viel Wert auf Atmosphäre gelegt wurde. Wir können diesen Ort wärmstens empfehlen!',
    rating: 5
  },
  {
    id: 3,
    category: 'Hochzeit',
    categoryIcon: Heart,
    name: 'Frauke Herbst',
    text: 'Großartige Hochzeit! Wir haben unsere Hochzeit hier gefeiert und alles war wirklich perfekt! Das Essen war super lecker und sah toll aus. Es wurde immer zügig nachgelegt. Selbst das Rindfleisch ging trotz vieler Rindfleischliebhaber aus Brasilien nicht zu Neige! Der Service war super freundlich und schnell. Unsere Gäste waren begeistert. Herr Reese und seine Frau sind auf all unsre Wünsche eingegangen und haben uns mit hilfreichen Tipps unterstützt. Auch die Preiskalkulation stimmte am Ende mit der Anfangskalkulation überein- wichtig für eine gute Planung. Wir würden immer wieder hier feiern und Freunde die unsere Gäste waren und demnächst heiraten werden dies auch tun. Wirklich top!',
    rating: 5
  },
  {
    id: 4,
    category: 'Firmenfeier',
    categoryIcon: Briefcase,
    name: 'Arnica Reiners',
    text: 'Wir feierten dort unser Betriebsfest von Helios. Knapp 1200 Menschen und alles war super organisiert 💯',
    rating: 5
  },
  {
    id: 5,
    category: 'Private Feier',
    categoryIcon: PartyPopper,
    name: 'Bernhard Roth',
    text: 'Ich habe mehrere Familienfeiern in gebuchten Räumen gehabt, kleine Abstecher zum Essen zwischendurch und mehrmals den Sonntagsbrunch genossen und bin rundum mit der Freundlichkeit und der Qualität und dem Preis/Leistungsverhältnis zufrieden. Wir kommen gerne wieder.',
    rating: 5
  },
  {
    id: 6,
    category: 'Party',
    categoryIcon: PartyPopper,
    name: 'D. Küppers',
    text: 'Nach ein paar Jahren Pause wieder "in der Hückels" Halloween feiern gewesen und es war richtig gut. Zwei Floors für alle was da gewesen! Publikum (jung und jungalt 😉) total nett! DJs sehr gut! Personal sehr freundlich! Verhungern kann man auch nicht. Es wurde vor Ort Pizza gebacken. Ich komme definitiv wieder!',
    rating: 5
  },
  {
    id: 7,
    category: 'Brunch',
    categoryIcon: Coffee,
    name: 'Astrid M.',
    text: 'Wir waren heute am 2. Weihnachtstag in HückelsMay. Das Ambiente sehr schön weihnachtlich geschmückt, das Essen war sehr lecker, Service schnell und gut organisiert. Wir hatten einen rundum schönen Brunch und haben uns sehr wohl gefühlt.',
    rating: 5
  },
  {
    id: 8,
    category: 'Firmenfeier',
    categoryIcon: Briefcase,
    name: 'Sven Wiszniewski',
    text: 'Absolut traumhafte Location für Firmenfeiern. Im Innenhof kommt man gemütlich und gesellig zusammen und innen fühlt man sich wohl. Perfekte Mischung aus Hof-, Land und Partyfeeling mit tollem Service und bester Ausstattung. Komme gerne immer wieder und freue mich auf das nächste Mal!',
    rating: 5
  },
  {
    id: 9,
    category: 'Private Feier',
    categoryIcon: Heart,
    name: 'May',
    text: 'Ich war letztens mit meinem Mann hier. Der Service und das Essen wirklich ausgezeichnet! Sehr romantisch, wir kommen auf jeden Fall wieder, vielen Dank!',
    rating: 5
  },
  {
    id: 10,
    category: 'Party',
    categoryIcon: PartyPopper,
    name: 'Tom Z.',
    text: 'Super freundliches Personal, wunderschöne Location und grandiose Partys!',
    rating: 5
  }
]

export default function Veranstaltungen() {
  const heroRef = useRef<HTMLDivElement>(null)
  const [currentTestimonial, setCurrentTestimonial] = useState(0)
  
  const { scrollYProgress } = useScroll()
  const heroOpacity = useTransform(scrollYProgress, [0, 0.15], [1, 0])
  const heroScale = useTransform(scrollYProgress, [0, 0.15], [1, 1.1])


  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => {
      // Wenn wir am Ende sind, gehe zurück zum Anfang
      if (prev >= testimonials.length - 1) {
        return 0
      }
      return prev + 1
    })
  }

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => {
      // Wenn wir am Anfang sind, gehe zum Ende
      if (prev <= 0) {
        return testimonials.length - 1
      }
      return prev - 1
    })
  }

  return (
    <div className="bg-[#0a0a0a]">
      
      {/* ════════════════════════════════════════════════════════════
          HERO SECTION - Compact Banner Style
      ════════════════════════════════════════════════════════════ */}
      <section ref={heroRef} className="relative h-[50vh] min-h-[400px] max-h-[550px] w-full overflow-hidden">
        {/* Image Background with Parallax */}
        <motion.div style={{ scale: heroScale }} className="absolute inset-0">
          <img
            src="/assets/heros/hero_bilder.jpg"
            alt="Veranstaltung bei Hückels May"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ filter: 'brightness(0.3)' }}
          />
        </motion.div>

        {/* Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />
        
        {/* Subtle Ruby Glow */}
        <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-brand-800/10 rounded-full blur-[120px]" />
        
        {/* Hero Content */}
        <motion.div 
          style={{ opacity: heroOpacity }}
          className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6 pt-16"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-4"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-xl border border-white/10 rounded-full">
              <Sparkles className="w-3 h-3 text-brand-400" />
              <span className="text-white/70 text-xs uppercase tracking-[0.25em]">Seit 1998</span>
            </div>
          </motion.div>

          {/* Main Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="font-serif text-3xl md:text-4xl lg:text-5xl text-white font-light tracking-tight leading-[1.1] mb-4"
          >
            Ihre Veranstaltung, <span className="italic text-white/70">unvergesslich</span> gestaltet
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="text-white/50 text-sm md:text-base max-w-xl mb-6 leading-relaxed"
          >
            Von der Traumhochzeit bis zum exklusiven Firmenevent – der perfekte Rahmen für Ihre besonderen Anlässe.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.7 }}
            className="flex flex-row gap-3"
          >
            <Link to="/kontakt">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="px-6 py-2.5 bg-white text-black text-xs uppercase tracking-[0.2em] font-bold rounded-full hover:bg-brand-800 hover:text-white transition-all duration-500"
              >
                Jetzt anfragen
              </motion.button>
            </Link>
            <Link to="/raeume">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="px-6 py-2.5 border border-white/30 text-white text-xs uppercase tracking-[0.2em] font-bold rounded-full hover:bg-white/10 transition-all duration-500 flex items-center gap-2"
              >
                Räume entdecken
                <ArrowRight className="w-3 h-3" />
              </motion.button>
            </Link>
          </motion.div>
        </motion.div>
      </section>


      {/* ════════════════════════════════════════════════════════════
          STATS BAR
      ════════════════════════════════════════════════════════════ */}
      <section className="border-y border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-4">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="py-10 md:py-12 px-6 text-center border-r border-white/5 last:border-r-0 group hover:bg-white/[0.02] transition-colors flex flex-col items-center justify-center h-[140px]"
              >
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-brand-800/10 border border-brand-800/20 mb-3 group-hover:scale-110 transition-transform">
                  <stat.icon className="w-4 h-4 text-brand-400" />
                </div>
                <p className="text-white text-sm font-medium mb-1">{stat.number}</p>
                <p className="text-white/40 text-xs">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════
          EVENT CATEGORIES - 3 Kacheln nebeneinander
      ════════════════════════════════════════════════════════════ */}
      <section className="relative py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          
          {/* Section Header - Kompakt */}
          <div className="flex items-end justify-between mb-10 md:mb-14">
            <div>
              <motion.p
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-brand-400 text-[10px] uppercase tracking-[0.3em] mb-2"
              >
                Ihr Event, Ihre Wahl
              </motion.p>
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="font-serif text-3xl md:text-4xl text-white font-light"
              >
                Was möchten Sie <span className="italic text-white/60">feiern?</span>
              </motion.h2>
            </div>
            
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <Link to="/raeume" className="inline-flex items-center gap-2 text-white/50 hover:text-white transition-colors group text-xs uppercase tracking-[0.15em]">
                <span>Unsere Räume</span>
                <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
              </Link>
            </motion.div>
          </div>

          {/* 3-Spalten Kachel-Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
            {eventCategories.map((category, index) => (
              <motion.div
                key={category.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Link 
                  to={category.link}
                  className="group block h-full"
                >
                  <div className="relative h-full rounded-2xl overflow-hidden border border-white/5 hover:border-white/15 transition-all duration-500 bg-[#111]">
                    {/* Bild */}
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img
                        src={category.image}
                        alt={category.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-[#111]/40 to-transparent" />
                      
                      {/* Icon Badge */}
                      <div className="absolute top-4 left-4 w-10 h-10 bg-brand-800/80 backdrop-blur-xl rounded-xl border border-brand-700/50 flex items-center justify-center">
                        <category.icon className="w-4 h-4 text-white" />
                      </div>
                      
                      {/* Capacity Badge */}
                      <div className="absolute bottom-4 left-4 px-3 py-1.5 bg-white/10 backdrop-blur-xl rounded-full border border-white/10">
                        <div className="flex items-center gap-2">
                          <Users className="w-3 h-3 text-white/60" />
                          <span className="text-white text-[11px]">{category.capacity}</span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Content */}
                    <div className="p-5">
                      <div className="flex items-start justify-between mb-2">
                        <div>
                          <p className="text-brand-400 text-[10px] uppercase tracking-[0.25em] mb-1">{category.tagline}</p>
                          <h3 className="font-serif text-xl text-white font-light">{category.title}</h3>
                        </div>
                        <div className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center transition-all duration-500 group-hover:bg-brand-800 group-hover:border-brand-800">
                          <ArrowUpRight className="w-4 h-4 text-white/40 transition-colors group-hover:text-white" />
                        </div>
                      </div>
                      <p className="text-white/40 text-sm leading-relaxed mb-4">{category.description}</p>
                      
                      {/* Features */}
                      <div className="flex flex-wrap gap-1.5">
                        {category.features.map((feature, idx) => (
                          <span 
                            key={idx}
                            className="text-[10px] px-2.5 py-1 rounded-full bg-white/5 text-white/50 border border-white/10"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════
          BUFFETS & ANGEBOTE SECTION
      ════════════════════════════════════════════════════════════ */}
      <section className="relative py-24 md:py-32 border-t border-white/5">
        <div className="absolute top-40 right-20 w-[500px] h-[500px] bg-brand-800/5 rounded-full blur-[120px]" />
        
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
            {/* Left - Content */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-800/10 border border-brand-800/20 rounded-full mb-6">
                <FileText className="w-4 h-4 text-brand-400" />
                <span className="text-brand-400 text-xs uppercase tracking-[0.2em]">Angebote</span>
              </div>
              
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white font-light mb-6">
                Buffets & <span className="italic text-white/60">Angebote</span>
              </h2>
              
              <div className="h-px w-20 bg-brand-800 mb-6" />
              
              <p className="text-white/60 leading-relaxed mb-8">
                Entdecken Sie unsere vielfältigen Buffetvorschläge und Pauschalangebote. 
                Von saisonalen Variationen bis hin zu individuellen Zusammenstellungen – 
                wir erstellen für Sie das perfekte Menü.
              </p>
              
              <Link to="/buffets-angebote">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black text-sm uppercase tracking-[0.2em] font-bold rounded-full hover:bg-brand-800 hover:text-white transition-all duration-500"
                >
                  Angebote ansehen
                  <ArrowRight className="w-4 h-4" />
                </motion.button>
              </Link>
            </motion.div>
            
            {/* Right - Visual */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-2xl overflow-hidden border border-white/10">
                <img
                  src="/assets/buffet.jpg"
                  alt="Buffets & Angebote"
                  className="w-full h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-brand-800/90 backdrop-blur-sm border border-brand-700/50 flex items-center justify-center shadow-lg">
                      <FileText className="w-6 h-6 text-white" />
                    </div>
                    <div className="bg-black/70 backdrop-blur-md rounded-xl px-4 py-3 border border-white/10 shadow-xl">
                      <p className="font-serif text-lg md:text-xl text-white font-medium drop-shadow-lg">Vielfältige Buffetauswahl</p>
                      <p className="text-white/90 text-sm md:text-base mt-1 drop-shadow-md">Individuelle Zusammenstellungen möglich</p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════
          WHY US
      ════════════════════════════════════════════════════════════ */}
      <section className="border-y border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-4">
            {whyUs.map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="py-10 md:py-12 px-6 text-center border-r border-white/5 last:border-r-0 group hover:bg-white/[0.02] transition-colors flex flex-col items-center justify-center h-[140px] overflow-hidden"
              >
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-brand-800/10 border border-brand-800/20 mb-3 group-hover:scale-110 transition-transform">
                  <item.icon className="w-4 h-4 text-brand-400" />
                </div>
                <p className="text-white text-sm font-medium mb-1">{item.title}</p>
                <p className="text-white/40 text-xs">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════
          TESTIMONIALS SLIDER - Horizontal Carousel
      ════════════════════════════════════════════════════════════ */}
      <section className="relative py-20 md:py-28 overflow-hidden border-t border-white/5">
        {/* Ambient Background */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-900/10 via-transparent to-transparent" />
        
        <div className="max-w-[1600px] mx-auto px-6 relative z-10">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-800/10 border border-brand-800/20 rounded-full mb-4 backdrop-blur-sm">
              <Star className="w-3.5 h-3.5 text-brand-400" />
              <span className="text-brand-400 text-xs uppercase tracking-[0.3em] font-semibold">Kundenstimmen</span>
            </div>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white font-light mb-3 tracking-tight">
              Was unsere Gäste <span className="italic text-brand-400">erleben</span>
            </h2>
            <p className="text-white/50 text-base max-w-xl mx-auto">
              Echte Erfahrungen von zufriedenen Gästen
            </p>
          </motion.div>

          {/* Horizontal Scrollable Container */}
          <div className="relative">
            {/* Navigation Buttons */}
            <motion.button
              onClick={prevTestimonial}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 hover:border-brand-800/50 flex items-center justify-center transition-all duration-300 group shadow-lg hover:shadow-brand-800/20 -ml-2 md:-ml-4"
              aria-label="Vorherige Bewertungen"
            >
              <ChevronLeft className="w-5 h-5 text-white/60 group-hover:text-brand-400 transition-colors" />
            </motion.button>

            <motion.button
              onClick={nextTestimonial}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 hover:border-brand-800/50 flex items-center justify-center transition-all duration-300 group shadow-lg hover:shadow-brand-800/20 -mr-2 md:-mr-4"
              aria-label="Nächste Bewertungen"
            >
              <ChevronRight className="w-5 h-5 text-white/60 group-hover:text-brand-400 transition-colors" />
            </motion.button>

            {/* Testimonials Horizontal Scroll */}
            <div className="overflow-hidden px-4 md:px-8">
              <motion.div 
                className="flex gap-4 md:gap-5"
                animate={{ 
                  x: `calc(-${currentTestimonial} * (260px + 1rem))`,
                }}
                transition={{ duration: 0.5, ease: [0.23, 1, 0.32, 1] }}
              >
                {testimonials.map((testimonial, index) => {
                  const IconComponent = testimonial.categoryIcon
                  return (
                    <motion.div
                      key={testimonial.id}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: index * 0.1 }}
                      className="w-[260px] md:w-[280px] flex-shrink-0"
                    >
                      <div className="relative group h-full">
                        {/* Card */}
                        <div className="relative bg-gradient-to-br from-zinc-900/60 via-zinc-900/70 to-black/80 backdrop-blur-xl border border-white/10 rounded-xl overflow-hidden shadow-lg hover:border-brand-800/30 transition-all duration-300 h-full flex flex-col">
                          {/* Top Accent */}
                          <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-brand-400/50 to-transparent" />
                          
                          {/* Content */}
                          <div className="p-4 flex flex-col flex-1">
                            {/* Header */}
                            <div className="flex flex-col gap-2 mb-3">
                              {/* Category */}
                              <div className="flex items-center gap-2 px-2.5 py-1 bg-gradient-to-r from-brand-800/20 to-brand-900/10 border border-brand-700/20 rounded-lg w-fit">
                                <IconComponent className="w-3 h-3 text-brand-400" />
                                <span className="text-brand-300 text-xs font-medium">
                                  {testimonial.category}
                                </span>
                              </div>
                              
                              {/* Stars */}
                              <div className="flex items-center gap-0.5">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                  <Star key={i} className="w-3 h-3 text-brand-400 fill-brand-400" />
                                ))}
                              </div>
                            </div>

                            {/* Quote */}
                            <blockquote className="relative z-10 text-white/90 text-xs leading-relaxed mb-3 flex-1">
                              <Quote className="w-5 h-5 text-brand-400/20 absolute -top-1 -left-1" />
                              <span className="relative">{testimonial.text}</span>
                            </blockquote>

                            {/* Author */}
                            <div className="flex items-center gap-2.5 pt-3 border-t border-white/5">
                              <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-br from-brand-800/30 to-brand-900/20 border border-brand-700/20 flex items-center justify-center">
                                <span className="text-brand-400 text-xs font-serif font-semibold">
                                  {testimonial.name.charAt(0)}
                                </span>
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="text-white font-medium text-xs truncate">
                                  {testimonial.name}
                                </p>
                                <p className="text-white/40 text-[10px]">Verifizierter Gast</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )
                })}
              </motion.div>
            </div>

            {/* Dots Indicator */}
            <div className="flex items-center justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`transition-all duration-300 rounded-full ${
                    index === currentTestimonial
                      ? 'w-8 h-2 bg-brand-400'
                      : 'w-2 h-2 bg-white/20 hover:bg-white/40'
                  }`}
                  aria-label={`Bewertung ${index + 1}`}
                />
              ))}
            </div>
          </div>

          {/* Trust Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="text-center mt-10"
          >
            <div className="inline-flex items-center gap-2 text-white/40 text-sm">
              <Award className="w-4 h-4 text-brand-400" />
              <span>Über 4500 erfolgreiche Events seit 1998</span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════
          CTA SECTION - Final Push
      ════════════════════════════════════════════════════════════ */}
      <section className="py-12 md:py-20">
        {/* Background Glows */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-800/5 rounded-full blur-[150px]" />
        
        <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-brand-800/10 border border-brand-800/20 mb-8">
              <Phone className="w-9 h-9 text-brand-400" />
            </div>
            
            <p className="text-brand-400 text-xs uppercase tracking-[0.4em] mb-6">Bereit?</p>
            
            <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white font-light mb-8 leading-tight">
              Lassen Sie uns Ihre<br />
              <span className="italic text-white/60">Veranstaltung</span> planen
            </h2>
            
            <p className="text-white/40 text-lg md:text-xl mb-12 max-w-2xl mx-auto">
              Kostenlose Beratung und ein unverbindliches Angebot – wir freuen uns auf Ihre Anfrage.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/kontakt">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                  className="px-14 py-5 bg-white text-black text-sm uppercase tracking-[0.3em] font-bold rounded-full hover:bg-brand-800 hover:text-white transition-all duration-500 flex items-center gap-3"
                >
                  <Phone className="w-5 h-5" />
                  Kontakt aufnehmen
                </motion.button>
              </Link>
              <Link to="/raeume">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="px-14 py-5 border border-white/20 text-white text-sm uppercase tracking-[0.3em] font-bold rounded-full hover:bg-white/5 transition-all duration-500 flex items-center gap-3"
                >
                  Räume ansehen
                  <ArrowRight className="w-5 h-5" />
                </motion.button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

    </div>
  )
}
